import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  parentIndex: number;
}

export default function InsuranceTable(props: Props) {
  const { t } = useTranslation();
  const name: any = `approvalable.documentPurchases.${props.parentIndex}.documentPurchaseGuests`;
  const _values = HOCWatchValue({ keys: [name] });
  const data = _values[name];

  const columns = [
    {
      header: t('common:guest'),
      accessorKey: 'guestName',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:type'),
      accessorKey: 'type',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:started_at'),
      accessorKey: 'startedAt',
      minSize: 100,
      dataType: ColumnDataType.date,
      required: true,
    },
    {
      header: t('common:ended_at'),
      accessorKey: 'endedAt',
      minSize: 100,
      dataType: ColumnDataType.date,
      required: true,
    },
    {
      header: t('common:days'),
      accessorKey: 'days',
      minSize: 20,
      dataType: ColumnDataType.number,
      minNumber: 0,
      required: true,
    },
    {
      header: t('common:package'),
      accessorKey: 'package',
      minSize: 100,
      dataType: ColumnDataType.text,
      required: true,
    },
    {
      header: t('common:company'),
      accessorKey: 'company',
      minSize: 100,
      dataType: ColumnDataType.text,
      required: true,
    },
    {
      header: t('common:cover_area'),
      accessorKey: 'coverArea',
      minSize: 100,
      dataType: ColumnDataType.text,
      required: true,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 300,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
      required: true,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={data}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
